// import Image from 'next/image';
import {
  useEffect, useRef, useState
} from 'react';
import { useInView } from 'react-intersection-observer';
import dynamic from 'next/dynamic';
import { RiPlayCircleFill, RiLoader2Line } from 'react-icons/ri';
import { useSelector, useDispatch } from 'react-redux';
import { updatePlayerSettings } from '@redux/player/playerSlice';
import style from './index.module.scss';

const PlayerControls = dynamic(() => import('./controls'), { ssr: false });

interface P {
  videoSrc: string;
  videoId?: string;
  thumbUrl?: string;
  classes?: string;
  priority?: boolean;
  aspectRatio?: any;
  playInview?: boolean;
}

export default function HtmlVideolayer({
  videoSrc,
  videoId = '',
  thumbUrl = '',
  classes = '',
  priority = false,
  aspectRatio = 16 / 9,
  playInview = true
}: P) {
  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [canPlay, setCanPlay] = useState(false);
  const played = useRef(false);
  const { ref, inView } = useInView({
    threshold: 0.7
  });
  const { volume = 1 } = useSelector((state: any) => state.player || {});
  const dispatch = useDispatch();

  useEffect(() => {
    if (playerRef.current) {
      const onChangePlay = (e) => {
        if (e.type === 'pause') {
          setIsPlaying(false);
        }
        if (e.type === 'play') {
          setIsPlaying(true);
          played.current = true;
          const audios = document.querySelectorAll('audio');
          audios.forEach((au) => au.pause());
          const videos = document.querySelectorAll('video');
          videos.forEach((v) => v.id !== videoId && v.pause());
        }
      };
      playerRef.current.onplay = onChangePlay;
      playerRef.current.onpause = onChangePlay;
    }
  }, []);

  useEffect(() => {
    if (playerRef.current) {
      if (playerRef.current.paused && inView) {
        const src = playerRef.current.getAttribute('data-src');
        playerRef.current.removeAttribute('preload');
        if (!playerRef.current.src) {
          playerRef.current.src = src; // Set the video source
          playerRef.current.removeAttribute('preload'); // No need to preload anymore
        }
        playerRef.current.volume = volume;
        playerRef.current.muted = volume === 0;
        playInview && canPlay && playerRef.current.play();
      } else {
        playerRef.current.played && playerRef.current.pause();
      }
    }
  }, [inView, canPlay]);

  return (
    <div ref={ref} className={`${style['vid-ctn']} ${classes}`}>
      {/* {thumbUrl && !played.current && !isPlaying && (
        <div
          className="vid-poster"
          onClick={() => {
            playerRef.current.play();
          }}
          aria-hidden
        >
          <Image
            fill
            unoptimized
            sizes="(max-width: 768px) 50vw, (max-width: 2100px) 20vw"
            priority={priority}
            loading={priority ? 'eager' : 'lazy'}
            src={thumbUrl}
            alt="thumb-video"
          />
          <RiPlayCircleFill />
        </div>
      )} */}
      {!isPlaying && !canPlay && <RiLoader2Line className={style.loader} />}
      <video
        aria-hidden
        onClick={() => {
          playerRef.current.paused ? playerRef.current.play() : playerRef.current.pause();
        }}
        onCanPlay={() => { setCanPlay(true); }}
        id={videoId}
        width="100%"
        height="auto"
        loop
        muted
        playsInline
        controls={false}
        preload="auto"
        ref={playerRef}
        style={{ aspectRatio, maxHeight: `calc(100vw * ${aspectRatio})` }}
        data-src={videoSrc}
      />
      <div className={style.overlay} style={{ backgroundImage: `url(${thumbUrl})` }} />
      {playerRef.current && (
        <PlayerControls
          playerRef={playerRef.current}
          isPlaying={isPlaying}
          setVolume={(v) => dispatch(updatePlayerSettings(v))}
          volume={volume}
        />
      )}
    </div>
  );
}
